import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import Loading from "../../Loading";
import Error from "../../components/Error";
import useDB from "../../hooks/useDB";

import Lang from "../../components/Lang";

import useDBO from "../../hooks/useDBO";
import Text from "../../components/Text";

import mut from "../../hooks/mut";
import ResourceList from "../../components/ResourceList";
import Info from "../../components/Info";
import ProgressHT from "../../components/ProgressHT";
import "./syllabus.css"
import CheckBox from "../../components/CheckBox";


export default function Unit({syllabuses}) {
    const { unit } = useParams();
    const [un, setUn, error, loading] = useDB(`/get-unit/${unit}`)
    
    if (loading) return <Loading />
    if(error) return <Error />

   console.log(un)
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            paddingTop: 10,
          }}
        >
          <div style={{ display: "flex", gap: 20 }}>
            <Text
              value={un.name}
              setValue={(name) => setUn({ ...un, name })}
              url={`/update-unit/${un._id}`}
              field="name"
              label={<Lang w="name" />}
              size="small"
              style={{ flexGrow: 1 }}
            />
          
            <Info
              title={`Percent completed ${parseInt(un.percentComplete) || 0}%`}
              body={<ProgressHT value={un.percentComplete} />}
            />
          </div>
          <Lessons
            unit={un}
            syllabuses={syllabuses}
          />

          <Text
            value={un.conversation}
            setValue={(conversation) => setUn({ ...un, conversation })}
            url={`/update-unit/${un._id}`}
            field="conversation"
            label={<Lang w="conversation" />}
            multiline
            rows={4}
          />
          <CheckBox
            label="No test"
            value={un.noTest}
            setValue={(noTest) => setUn({ ...un, noTest })}
            url={`/update-unit/${un._id}`}
            field="noTest"
          />
          {!un.noTest && (
          <div><ResourceList
            value={un}
            setValue={setUn}
            label={<Lang w="tests" />}
            field="tests"
            url={`/update-unit/${un._id}`}
            defaultName={`Test U${un.unitNumber}`}
            disabled={un.noTest}
          />
          <ResourceList
            value={un}
            setValue={setUn}
            label={<Lang w="testPowerpoints" />}
            field="testppt"
            url={`/update-unit/${un._id}`}
            defaultName={`Test PPT U${un.unitNumber}`}
            disabled={un.noTest}
          /></div>)}
        </div>
      </div>
    );
}


function Lessons({ unit, syllabuses}) {
    
  /*    const [openNewLesson, setOpenNewLesson] = useState(false) */
  const [name, setName] = useState("")
  const navigate= useNavigate()
    const lessons = useDBO(`/get-unit-lessons/${unit._id}`)

  if (lessons.loading) return <Loading />
  if (lessons.error) return <Error />
  
  const checkKey = async (e) => {
    if (e.keyCode === 13 && name.length>0) {
     let res = await mut("put", "/add-lesson/", {
        syllabus: unit.syllabus._id,
        unit: unit._id,
        name
     });
      lessons.add(res)
      let syllabus = syllabuses.findById(res.syllabus)
      syllabus.lessons.push(res)
      syllabuses.update(syllabus)
      setName("")
    }
  }

    return (
      <div>
        <div>
          {" "}
          <Lang w="lessons" />
        </div>
        <div style={{ marginBottom: 10 }}>
          {lessons.get.length > 0 ? (
            lessons.get.map((lesson) => (
              <div
                key={lesson._id}
                className="lesson-button"
                onClick={() =>
                  navigate(
                    `/teaching/syllabus/${unit.syllabus._id}/unit/${unit._id}/lesson/${lesson._id}`
                  )
                }
              >
                {/*  <Link
                  to={`/teaching/syllabus/${unit.syllabus._id}/unit/${unit._id}/lesson/${lesson._id}`}
                  className="neat"
                > */}
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    Lesson {lesson.lessonNumber} - {lesson.name}{" "}
                    {lesson.issues &&
                      lesson.issues > 0 &&
                      ` - ${lesson.issues} issues`}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      color: "#888",
                      fontSize: 12,
                      width: 130,
                      marginRight: 10,
                    }}
                  >
                    <div style={{ width: 100 }}>
                      <ProgressHT value={lesson.percentComplete} />
                    </div>
                    <div style={{ width: 20, textAlign: "center" }}>
                      {parseInt(lesson.percentComplete) || 0}%
                    </div>
                  </div>
                </div>
                {/*  </Link> */}
              </div>
            ))
          ) : (
            <div>No lessons</div>
          )}
        </div>
        <TextField
          value={name}
          onChange={(e) => setName((prev) => e.target.value)}
          label={<Lang w="addANewLesson" />}
          size="small"
          sx={{ width: 600 }}
          onKeyUp={checkKey}
        />
      </div>
    );
    
}


